













































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Typography, Surface } from '@/components/atoms';
import { Radio } from '@/components/molecules';
import CalendarIcon from '@/components/icons/Calendar.vue';
import DatePicker from '@/components/DatePicker/DatePicker.vue';
import isMobile from '@/utils/mobile-check';

@Component({
  components: {
    Typography,
    Surface,
    Radio,
    CalendarIcon,
    DatePicker
  }
})
export default class DateSectionSetting extends Vue {
  @Prop({ default: 'no-deadline' }) readonly value!: string;
  @Prop({ default: false }) readonly hasError?: boolean;
  @Prop({ default: true }) hasHeader?: boolean;
  @Prop() placeholderValue?: string;

  get isMobileDevice() {
    return isMobile();
  }

  handleChangeExpiration(date: string) {
    this.$emit('inputExpiration', date);
  }

  get tPrefix() {
    return 'sellCoins.campaign.dateSection';
  }
}
